module.exports = __webpack_public_path__ + "static/media/scventures.0f1b3cf1.png";